var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tip)?_c('el-tooltip',{attrs:{"effect":"light","content":_vm.value,"placement":"top"}},[_c('span',[_vm._v(_vm._s(_vm.showVal))])]):_c('span',[_vm._v(_vm._s(_vm.showVal))])],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }